import { get } from 'lodash'

import { BACKEND_BASE_URL } from '../constants/baseUrl'

import { getToken } from './sessionStorage'
import { disconnect } from './disconnect'

const sampleDelay = 0

export const fetchApi = async ({
  path, body = undefined, method = 'POST', headers = {},
}) => {
  await new Promise((res) => setTimeout(res, sampleDelay))

  if (!path) {
    // eslint-disable-next-line no-console
    console.error('FetchAPI: You need to specify a path')
  }
  const baseHeaders = {
    'Content-Type': 'application/json',
  }
  const token = getToken()
  if (token) {
    baseHeaders.Authorization = `Bearer ${token}`
  }
  const options = {
    method,
    headers: new Headers({
      ...baseHeaders,
      ...headers,
    }),
  }
  if (body) {
    options.body = JSON.stringify(body)
  }
  const response = await fetch(`${BACKEND_BASE_URL}${path}`, options)

  let data
  if (response.status !== 204) {
    data = await response.json()
  }
  // need to handle 401 here
  if (get(data, 'errorCode') === 12000) {
    disconnect()
  }
  // code injection attempt detected
  if (get(data, 'errorCode') === 20000) {
    alert('Erreur dans le formulaire, caractères spéciaux détéctés')
  }

  if (response.ok) {
    return data
  }
  throw data
}
